import React from "react";
import Link from "../Link";
import { RightArrow, RightChevron } from "../Icons";
import s from "./FancyLink.module.css";

function FancyLink({
  link,
  icon = "",
  tag = "",
  tag_color = "",
  description = "",
  arrow = "chevron",
  blackLabel = false,
}) {
  return (
    <Link settings={link} className={s["fancy-link"]}>
      {icon && <img className={s.icon} src={icon} />}

      <div>
        <div
          className={[s.label, blackLabel ? s["black-label"] : ""].join(" ")}
        >
          {link.label}
          {arrow === "chevron" && <RightChevron className={s.chev} />}
          {arrow === "arrow" && <RightArrow className={s.arr} />}
          {tag && (
            <em
              className={[
                s.tag,
                arrow === "chevron" ? s["chev-move"] : "",
                arrow === "arrow" ? s["arr-move"] : "",
              ].join(" ")}
              style={{ backgroundColor: tag_color }}
            >
              {tag}
            </em>
          )}
        </div>

        {description && <p className={s.description}>{description}</p>}
      </div>
    </Link>
  );
}

export default FancyLink;
